// The menu-item area: "Menu item metrics" controls, the lazy products chart and the metrics
// table (products_block.coffee composition). The products chart carries the live-axis bridge
// for the block's display range (D11) via onChartReady.

import PropTypes from 'prop-types'
import { answerPropType } from '@aytm/app/stats/page/question-views/components/lib/prop-types'

import { isMapOrNone } from '@aytm/app/stats/page/components/lib/utils'
import { isComponentOn } from '@aytm/app/stats/page/question-views/components/lib/utils'
import ChartPlaceholder from '@aytm/app/stats/page/question-views/components/charts/placeholders/Chart'
import Table from '@aytm/app/stats/components/data-views/table/components/Table'

import ProductMetricsControls from '@aytm/app/stats/page/question-views/mn/components/products-section/ProductMetricsControls'
import ProductsChart from '@aytm/app/stats/page/question-views/mn/components/products-section/chart/ProductsChart'
import { calcProductsTable } from '@aytm/app/stats/page/question-views/mn/components/products-section/lib/productsTable'
import { PRODUCT_VIEW_OPTIONS } from '@aytm/app/stats/page/question-views/mn/lib/viewOptions'

const ProductsSection = ({
  components,
  answer,
  answerVariants,
  isAnimated,
  productViewMode,
  productsCollapsed,
  chartMode,
  globalChartMode,
  tableProps,
  chartProps,
  onModelChange,
  onToggle,
  onChartReady
}) => (
  <>
    {isComponentOn(components, 'controls') && (
      <ProductMetricsControls
        title="Menu item metrics"
        options={PRODUCT_VIEW_OPTIONS}
        viewMode={productViewMode}
        collapsed={productsCollapsed}
        onModelChange={onModelChange}
        onToggle={onToggle}
      />
    )}
    {!productsCollapsed && (
      <>
        {isComponentOn(components, 'chart') && !isMapOrNone(chartMode, globalChartMode) && (
          <ChartPlaceholder isLoading={'loading' === answer} isAnimated={isAnimated}>
            {'loading' !== answer && (
              <ProductsChart
                viewMode={productViewMode}
                answerVariants={answerVariants}
                answer={answer}
                onChartReady={onChartReady}
                {...chartProps}
              />
            )}
          </ChartPlaceholder>
        )}
        {isComponentOn(components, 'table') && <Table {...calcProductsTable(tableProps)} />}
      </>
    )}
  </>
)

ProductsSection.propTypes = {
  components: PropTypes.object,
  answer: answerPropType,
  answerVariants: PropTypes.array,
  isAnimated: PropTypes.bool,
  productViewMode: PropTypes.string,
  productsCollapsed: PropTypes.bool,
  chartMode: PropTypes.string,
  globalChartMode: PropTypes.string,
  tableProps: PropTypes.object,
  chartProps: PropTypes.object,
  onModelChange: PropTypes.func,
  onToggle: PropTypes.func,
  onChartReady: PropTypes.func
}

ProductsSection.displayName = 'ProductsSection'

export default ProductsSection
